import styled from "styled-components";
import { RdoPeriodoSectionVm } from "./rdoOperacoes.types";
import { summarizeRdoPeriodoStatus } from "./summarizeRdoPeriodoStatus";
import RdoPeriodoSummaryCard from "./RdoPeriodoSummaryCard";

type Props = {
  sections: RdoPeriodoSectionVm[];
};

function RdoPeriodoSummaryRow({ sections }: Props) {
  if (!sections.length) return null;

  return (
    <Row>
      {sections.map((section) => (
        <RdoPeriodoSummaryCard
          key={section.safraPeriodoId}
          titulo={section.titulo}
          ocupacao={section.ocupacao}
          summary={summarizeRdoPeriodoStatus(section.rows)}
        />
      ))}
    </Row>
  );
}

export default RdoPeriodoSummaryRow;

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;

  > * {
    flex: 0 0 362px;
    max-width: 362px;
  }
`;
